<template>
    <div class="consultation-header2">
        <div>
            <img src="@/assets/image/sdk-banner.png" alt="" style="width:100%;margin-top: 80px">
        </div>
        <div>
        <div class="header-first">
            <div style="display: flex;margin-top: 35px;" class="gaoliang">
                <div class="liang" style="cursor: pointer;width: 227px;height: 378px;background: #FFFFFF;border-radius: 10px;border: 1px solid #eee;display: flex;flex-direction: column;align-items: center;">
                    <img src="@/assets/image/789.png" alt="" style="margin-top: 31px;">
                    <div style="margin-top: 10px;"><span style="font-size: 24px;color: #0E71EB;">音视频通话</span></div>
                    <div style="margin-top: 10px;width: 164px;height: 89px;font-size: 16px;color: #6C6C6C;line-height: 24px;">通过集成SDK，轻松构建1对1和多人的实时音视频通话，可支持4K分辨率</div>
                </div>
                <div  class="liang" style="cursor: pointer;margin-left: 20px;width: 227px;height: 378px;background: #FFFFFF;border-radius: 10px;border: 1px solid #eee;display: flex;flex-direction: column;align-items: center;">
                    <img src="@/assets/image/790.png" alt="" style="margin-top: 31px;">
                    <div style="margin-top: 10px;"><span style="font-size: 24px;color: #0E71EB;">视频会议</span></div>
                    <div style="margin-top: 10px;width: 164px;height: 89px;font-size: 16px;color: #6C6C6C;line-height: 24px;">集成API/SDK，让系统轻松嵌入红杉会议全套功能</div>
                </div>
                <div  class="liang" style="cursor: pointer;margin-left: 20px;width: 227px;height: 378px;background: #FFFFFF;border-radius: 10px;border: 1px solid #eee;display: flex;flex-direction: column;align-items: center;">
                    <img src="@/assets/image/791.png" alt="" style="margin-top: 31px;">
                    <div style="margin-top: 10px;"><span style="font-size: 24px;color: #0E71EB;">实时录播</span></div>
                    <div style="margin-top: 10px;width: 164px;height: 89px;font-size: 16px;color: #6C6C6C;line-height: 24px;">实时录制音视频交互过程为MP4文件，通过API获取和点播</div>
                </div>
                <div  class="liang" style="cursor: pointer;margin-left: 20px;width: 227px;height: 378px;background: #FFFFFF;border-radius: 10px;border: 1px solid #eee;display: flex;flex-direction: column;align-items: center;">
                    <img src="@/assets/image/792.png" alt="" style="margin-top: 31px;">
                    <div style="margin-top: 10px;"><span style="font-size: 24px;color: #0E71EB;">互动直播</span></div>
                    <div style="margin-top: 10px;width: 164px;height: 89px;font-size: 16px;color: #6C6C6C;line-height: 24px;">实时推流直播，通过API获取直播流，嵌入到业务系统中</div>
                </div>
                <div  class="liang" style="cursor: pointer;margin-left: 20px;width: 227px;height: 378px;background: #FFFFFF;border-radius: 10px;border: 1px solid #eee;display: flex;flex-direction: column;align-items: center;">
                    <img src="@/assets/image/793.png" alt="" style="margin-top: 31px;">
                    <div style="margin-top: 10px;"><span style="font-size: 24px;color: #0E71EB;">即时通信</span></div>
                    <div style="margin-top: 10px;width: 164px;height: 89px;font-size: 16px;color: #6C6C6C;line-height: 24px;">提供即时通信SDK接口，实现远端消息的发送或广播</div>
                </div>
            </div>
            <div>
            <div class="header-first3">
              <div style="display:flex;">
                  <div style="margin-left:45px;margin-top:100px">
                      <div style="display:flex">
                          <div style="margin-left:8px">
                              <div style="font-size: 24px;color: #000000;">全平台支持，私有化部署</div>
                              <p style="width: 446px;font-size: 16px;color: #656B90;"><img src="@/assets/image/ling.png" alt="" style="width:13px;height:13px;margin-top:38px"><span style="margin-left:8px">提供各个平台的集成SDK和集成Demo，让集成更简单</span></p>
                              <p style="width: 446px;font-size: 16px;color: #656B90;"><img src="@/assets/image/ling.png" alt="" style="width:13px;height:13px;margin-top:15px"><span style="margin-left:8px">支持 Windows\Mac\Android\iOS\国产化\Web</span></p>
                          </div>
                      </div>
                  </div>
                   <img src="@/assets/image/duotu.png" alt="" style="margin-left:50px;margin-top: 40px;">
              </div>
          </div>
         </div>
          </div>
          <div style="background: #EBF3FE;">
            <div class="header-first4">
              <div style="display:flex;">
                <img src="@/assets/image/sdk2.png" alt="" style="margin-left:50px;margin-top: 40px;">
                  <div style="margin-left:80px;margin-top:200px">
                      <div style="display:flex">
                          <div style="margin-left:8px">
                              <div style="font-size: 24px;color: #000000;">多种协议兼容</div>
                              <p style="width: 446px;font-size: 16px;color: #656B90;"><img src="@/assets/image/ling.png" alt="" style="width:13px;height:13px;margin-top:38px"><span style="margin-left:8px">支持各类主流协议的接入，实现现有音视频硬件的兼容</span></p>
                              <p style="width: 446px;font-size: 16px;color: #656B90;"><img src="@/assets/image/ling.png" alt="" style="width:13px;height:13px;margin-top:15px"><span style="margin-left:8px">HST/H323/SIP/RTMP/RTSP/WebRTC</span></p>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
        <div class="header-first5">
              <div style="display:flex;">
                  <div style="margin-left:45px;margin-top:140px">
                      <div style="display:flex">
                          <div style="margin-left:8px">
                              <div style="font-size: 24px;color: #000000;">AI 能力支持</div>
                              <p style="width: 446px;font-size: 16px;color: #656B90;"><img src="@/assets/image/ling.png" alt="" style="width:13px;height:13px;margin-top:38px"><span style="margin-left:8px">可根据需要支持AI能力，包括人脸识别、语音转文字、</span></p>
                              <p style="font-size: 16px;color: #656B90;margin-left: 20px;height:13px;margin-top: 8px;">会议纪要、实时字幕等</p>
                          </div>
                      </div>
                  </div>
                   <img src="@/assets/image/sdk3.png" alt="" style="margin-left:50px;margin-top: 40px;">
              </div>
          </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss">
    .consultation-header2{
        width: 100%;
        .header-first{
            height: 710px;
            width:1200px;
            margin:0 auto;
        }
        .header-send{
            height: 690px;
            background: #EBF3FE;
        }
    }
    .gaoliang .liang{
        box-shadow: 0 0 .3vw rgba(0, 0, 0, .1);
        transition: transform .3s ease;
    }
     .gaoliang .liang:hover{
        background: linear-gradient(0deg, #e4f0ff, #fff) no-repeat !important;
        transform: translateY(-10px); 
    }
    .header-first3{
            height: s20px;
            width:1200px;
            margin:0 auto;
            margin-top: 30px;
        }
    .header-first4{
            height: 540px;
            width:1200px;
            margin:0 auto;
            margin-top: 30px;
    }
    .header-first5{
            height: 440px;
            width:1200px;
            margin:0 auto;
            margin-top: 30px;
    }
</style>